import { CoreProvider } from 'contexts/Core';
import { ExportCsvProvider } from 'contexts/ExportCsv';
import React, { Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18next from './locales/i18n';
import RouterNavigate from './routes';

const App = () => (
  <div data-testid="app-root" className="beneficiariesV2">
    <div className="app-general-beneficiary">
      <div className="app-container-beneficiary">
        <Suspense fallback={<></>}>
          {/* // comentar pra rodar local */}
          <CoreProvider>
            <I18nextProvider i18n={i18next}>
              <ExportCsvProvider>
                <RouterNavigate />
              </ExportCsvProvider>
            </I18nextProvider>
          </CoreProvider>
        </Suspense>
      </div>
    </div>
  </div>
);

export default App;
